import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type Guest } from '@/group/domain/guest.ts';

const initialState: Guest = {
    accesses: [],
    expiration: '',
    start: '',
};

const guestSlice = createSlice({
    initialState,
    name: 'guest',
    reducers: {
        clearGuest: () => initialState,
        setGuest: (state, action: PayloadAction<Guest>) => action.payload,
        updateGuestProps: (state, action: PayloadAction<Guest>) => ({ ...state, ...action.payload }),
    },
});

export const { setGuest, clearGuest, updateGuestProps } = guestSlice.actions;
export default guestSlice.reducer;